<template>
  <div :class="bem.b()">
    <div :class="bem.e('content')">
      <Tabs
        v-model:active-key="activeKey"
        :class="bem.m('cron-list')"
        size="small"
        type="card"
        :tab-bar-gutter="0"
      >
        <TabPane v-if="!hideSecond" key="second" tab="秒">
          <SecondUI v-model:value="second" :disabled="disabled" />
        </TabPane>
        <TabPane key="minute" tab="分">
          <MinuteUI v-model:value="minute" :disabled="disabled" />
        </TabPane>
        <TabPane key="hour" tab="时">
          <HourUI v-model:value="hour" :disabled="disabled" />
        </TabPane>
        <TabPane key="day" tab="日">
          <DayUI v-model:value="day" :week="week" :disabled="disabled" />
        </TabPane>
        <TabPane key="month" tab="月">
          <MonthUI v-model:value="month" :disabled="disabled" />
        </TabPane>
        <TabPane key="week" tab="周">
          <WeekUI v-model:value="week" :day="day" :disabled="disabled" />
        </TabPane>
        <TabPane v-if="!hideYear && !hideSecond" key="year" tab="年">
          <YearUI v-model:value="year" :disabled="disabled" />
        </TabPane>
      </Tabs>
      <div style="margin-bottom: 14px">结果</div>
      <!-- 执行时间预览 -->
      <div :class="bem.m('cron-result')">
        <Row :gutter="8">
          <Col :span="24">
            <Row :gutter="8">
              <Col :span="24" :class="bem.m('time-list')">
                <ll-input
                  v-if="!hideSecond"
                  v-model:value="inputValues.second"
                  :allow-clear="false"
                  @blur="onInputBlur"
                >
                  <template #addonBefore>
                    <span
                      :class="bem.m('allow-click')"
                      @click="activeKey = 'second'"
                    >
                      秒
                    </span>
                  </template>
                </ll-input>
                <ll-input
                  v-model:value="inputValues.minute"
                  :allow-clear="false"
                  @blur="onInputBlur"
                >
                  <template #addonBefore>
                    <span
                      :class="bem.m('allow-click')"
                      @click="activeKey = 'minute'"
                    >
                      分
                    </span>
                  </template>
                </ll-input>
                <ll-input
                  v-model:value="inputValues.hour"
                  :allow-clear="false"
                  @blur="onInputBlur"
                >
                  <template #addonBefore>
                    <span
                      :class="bem.m('allow-click')"
                      @click="activeKey = 'hour'"
                    >
                      时
                    </span>
                  </template>
                </ll-input>
                <ll-input
                  v-model:value="inputValues.day"
                  :allow-clear="false"
                  @blur="onInputBlur"
                >
                  <template #addonBefore>
                    <span
                      :class="bem.m('allow-click')"
                      @click="activeKey = 'day'"
                    >
                      日
                    </span>
                  </template>
                </ll-input>
                <ll-input
                  v-model:value="inputValues.month"
                  :allow-clear="false"
                  @blur="onInputBlur"
                >
                  <template #addonBefore>
                    <span
                      :class="bem.m('allow-click')"
                      @click="activeKey = 'month'"
                    >
                      月
                    </span>
                  </template>
                </ll-input>
                <ll-input
                  v-model:value="inputValues.week"
                  :allow-clear="false"
                  @blur="onInputBlur"
                >
                  <template #addonBefore>
                    <span
                      :class="bem.m('allow-click')"
                      @click="activeKey = 'week'"
                    >
                      周
                    </span>
                  </template>
                </ll-input>
                <ll-input
                  v-if="!hideYear && !hideSecond"
                  v-model:value="inputValues.year"
                  :allow-clear="false"
                  @blur="onInputBlur"
                >
                  <template #addonBefore>
                    <span
                      :class="bem.m('allow-click')"
                      @click="activeKey = 'year'"
                    >
                      年
                    </span>
                  </template>
                </ll-input>
              </Col>
              <Col :span="24" :class="bem.e('time-result-list')">
                <ll-input
                  v-model:value="inputValues.cron"
                  :allow-clear="false"
                  @blur="onInputCronBlur"
                >
                  <template #addonBefore>
                    <ll-tooltip tip="Cron表达式">
                      <span :class="bem.m('addon-before')"> Cron表达式 </span>
                    </ll-tooltip>
                  </template>
                </ll-input>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style="margin-top: 20px; width: 830px">
          <Col :span="24">
            <div style="margin-bottom: 8px">近十次执行时间（不含年）</div>
            <ll-textarea :value="preTimeList" :rows="3" />
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { useDebounceFn } from '@vueuse/core'
import { Col, Row, TabPane, Tabs } from 'ant-design-vue'
import CronParser from 'cron-parser'
import { computed, reactive, ref, watch } from 'vue'
import {
  cronExpressionBuilderEmits,
  cronExpressionBuilderProps,
  formatToDateTime,
} from '../config'
import DayUI from './tabs/day-ui.vue'
import HourUI from './tabs/hour-ui.vue'
import MinuteUI from './tabs/minute-ui.vue'
import MonthUI from './tabs/month-ui.vue'
import SecondUI from './tabs/second-ui.vue'
import WeekUI from './tabs/week-ui.vue'
import YearUI from './tabs/year-ui.vue'

const bem = createNamespace('cron-inner')
defineOptions({ name: 'CronInner' })
const props = defineProps(cronExpressionBuilderProps)
const emits = defineEmits(cronExpressionBuilderEmits)

const activeKey = ref(props.hideSecond ? 'minute' : 'second')
const second = ref('*')
const minute = ref('*')
const hour = ref('*')
const day = ref('*')
const month = ref('*')
const week = ref('?')
const year = ref('*')
const inputValues = reactive({
  second: '',
  minute: '',
  hour: '',
  day: '',
  month: '',
  week: '',
  year: '',
  cron: '',
})
const preTimeList = ref('执行预览，会忽略年份参数。')

// cron表达式
const cronValueInner = computed(() => {
  const result: string[] = [] as string[]
  if (!props.hideSecond) {
    result.push(second.value ? second.value : '*')
  }
  result.push(minute.value ? minute.value : '*')
  result.push(hour.value ? hour.value : '*')
  result.push(day.value ? day.value : '*')
  result.push(month.value ? month.value : '*')
  result.push(week.value ? week.value : '?')
  if (!props.hideYear && !props.hideSecond)
    result.push(year.value ? year.value : '*')
  return result.join(' ')
})
// 不含年
const cronValueNoYear = computed(() => {
  const v = cronValueInner.value
  if (props.hideYear || props.hideSecond) return v
  const vs = v.split(' ')
  if (vs.length >= 6) {
    // 转成 Quartz 的规则
    vs[5] = convertWeekToQuartz(vs[5])
  }
  return vs.slice(0, vs.length - 1).join(' ')
})
const calTriggerList = useDebounceFn(calTriggerListInner, 500)

watch(
  () => props.value,
  (newVal) => {
    if (newVal === cronValueInner.value) {
      return
    }
    formatValue()
  },
  { immediate: true }
)

watch(cronValueInner, (newValue) => {
  calTriggerList()
  emitValue(newValue)
  assignInput()
})

assignInput()
formatValue()
calTriggerListInner()

function assignInput() {
  inputValues.second = second.value
  inputValues.minute = minute.value
  inputValues.hour = hour.value
  inputValues.day = day.value
  inputValues.month = month.value
  inputValues.week = week.value
  inputValues.year = year.value
  inputValues.cron = cronValueInner.value
  if (!props.value) emitValue(inputValues.cron)
}
function formatValue() {
  if (!props.value) return
  const values = props.value.split(' ').filter((item: any) => !!item)
  if (!values || values.length <= 0) return
  let i = 0
  if (!props.hideSecond) second.value = values[i++]
  if (values.length > i) minute.value = values[i++]
  if (values.length > i) hour.value = values[i++]
  if (values.length > i) day.value = values[i++]
  if (values.length > i) month.value = values[i++]
  if (values.length > i) week.value = values[i++]
  if (values.length > i) year.value = values[i]
  assignInput()
}
// Quartz 的规则：
// 1 = 周日，2 = 周一，3 = 周二，4 = 周三，5 = 周四，6 = 周五，7 = 周六
function convertWeekToQuartz(week: string) {
  const convert = (v: string) => {
    if (v === '0') {
      return '1'
    }
    if (v === '1') {
      return '0'
    }
    return (Number.parseInt(v) - 1).toString()
  }
  // 匹配示例 1-7 or 1/7
  const patten1 = /^([0-7])([-/])([0-7])$/
  // 匹配示例 1,4,7
  const patten2 = /^([0-7])(,[0-7])+$/
  if (/^[0-7]$/.test(week)) {
    return convert(week)
  } else if (patten1.test(week)) {
    return week.replace(patten1, (_$0, before, separator, after) => {
      if (separator === '/') {
        return convert(before) + separator + after
      } else {
        return convert(before) + separator + convert(after)
      }
    })
  } else if (patten2.test(week)) {
    return week
      .split(',')
      .map((v) => convert(v))
      .join(',')
  }
  return week
}
function calTriggerListInner() {
  // 设置了回调函数
  if (props.remote) {
    props.remote(cronValueInner.value, +new Date(), (v) => {
      preTimeList.value = v
    })
    return
  }
  const options = {
    currentDate: formatToDateTime(new Date()),
  }
  const iter = CronParser.parseExpression(cronValueNoYear.value, options)
  const result: string[] = []
  for (let i = 1; i <= 10; i++) {
    result.push(formatToDateTime(new Date(iter.next() as any)))
  }
  preTimeList.value = result.length > 0 ? result.join('\n') : '无执行时间'
}
function onInputBlur() {
  second.value = inputValues.second
  minute.value = inputValues.minute
  hour.value = inputValues.hour
  day.value = inputValues.day
  month.value = inputValues.month
  week.value = inputValues.week
  year.value = inputValues.year
}
function onInputCronBlur(event) {
  emitValue(event.target.value)
}
function emitValue(value) {
  emits('change', value)
  emits('update:value', value)
}
</script>
<!-- <style lang="less">
@import 'easy.cron.inner.less';
</style> -->
